export class AttributionData {
  // These properties will be set at a future date
  utmCampaignFirst: string = '';
  utmCampaignLast: string = '';
  utmSourceFirst: string = '';
  utmSourceLast: string = '';
  utmMediumFirst: string = '';
  utmMediumLast: string = '';
  utmContentFirst: string = '';
  utmContentLast: string = '';
  utmTermFirst: string = '';
  utmTermLast: string = '';
  utmDeviceFirst: string = '';
  utmDeviceLast: string = '';
  referrerFirst: string = '';
  referrerLast: string = '';
  landingPageFirst: string = '';
  landingPageLast: string = '';
  gclidFirst: string = '';
  gclidLast: string = '';
  heapId: string;

  constructor(heapId: string) {
    this.heapId = heapId;
  }
}
